import ReconnectingWebSocket from 'ReconnectingWebSocket'
import Api from './../api'
import { publicConfig } from '@/config/runtime'

export default function register(DataLayer) {
    DataLayer.$extend('stationsPlaylists', {
        get(channel, after, limit = 12, offset = 0) {
            return Api.stationsPlaylists.get({ station: channel, after: after.toISOString(), limit, offset })
        },

        _processNowPlayingResponse(error, message) {
            if (error) {
                return Promise.reject(error)
            }

            return Promise.resolve({
                meta: {
                    model: 'StationsPlaylist',
                },
                body: message,
            })
        },
    })

    const NowPlaying = (function NowPlayingController() {
        let cachedResponse = null
        let socket = null
        const subscribers = []

        const notify = response => {
            cachedResponse = response
            subscribers.forEach(cb => cb(response))
        }

        const handleMessage = function (event) {
            const rawBody = JSON.parse(event.data)
            DataLayer.$wrap(() =>
                Promise.resolve({
                    meta: {
                        model: 'StationsPlaylist',
                    },
                    body: rawBody,
                })
            )()
                .then(notify)
                .catch(() => notify({ body: rawBody }))
        }

        const handleError = function (event) {
            DataLayer.stationsPlaylists._processNowPlayingResponse(event).catch(() => {})
        }

        const openSocket = () => {
            if (socket || typeof window === 'undefined') return

            socket = new ReconnectingWebSocket(publicConfig().apiNowPlaying, null, { reconnectInterval: 4000 })
            socket.addEventListener('message', handleMessage)
            socket.addEventListener('error', handleError)
        }

        const closeSocket = () => {
            if (!socket) return

            socket.removeEventListener('message', handleMessage)
            socket.removeEventListener('error', handleError)
            socket.close()
            socket = null
            cachedResponse = null
        }

        return {
            subscribe: function (cb) {
                subscribers.push(cb)
                openSocket()
                cachedResponse && cb(cachedResponse)
                // Clean up subscriptions and prevent them from firing forever
                return function unsubscribe() {
                    const index = subscribers.indexOf(cb)
                    if (index > -1) subscribers.splice(index, 1)
                    if (!subscribers.length) closeSocket()
                }
            },
        }
    })()

    // Allow callers to unsubscribe and clean up
    DataLayer.stationsPlaylists.subscribe = cb => NowPlaying.subscribe(cb)
}
